import Nullstack from 'nullstack';
export default function IconCubeSend({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cube-send",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 12.5l-5 -3l5 -3l5 3v5.5l-5 3z"
  }), "   ", Nullstack.element("path", {
    d: "M11 9.5v5.5l5 3"
  }), "   ", Nullstack.element("path", {
    d: "M16 12.545l5 -3.03"
  }), "   ", Nullstack.element("path", {
    d: "M7 9h-5"
  }), "   ", Nullstack.element("path", {
    d: "M7 12h-3"
  }), "   ", Nullstack.element("path", {
    d: "M7 15h-1"
  }), " ");
}